import './contact.scss';
console.log('contact.js');
